import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { IAlert } from './alert.interface';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
})
export class AlertComponent {
  @Input() alert: IAlert | null | undefined;
  @Output() cerrarAlerta = new EventEmitter<void>();

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: IAlert, public snackBarRef?: MatSnackBarRef<AlertComponent>) {
    if (data) this.alert = data;
  }

  close() {
    this.cerrarAlerta.emit();
    if (this.snackBarRef?.instance) {
      this.snackBarRef.dismiss();
    } else {
      this.alert = null;
    }
  }
}
